<script>
/**
 * BaileysConnection.vue
 * Componente para gerenciar conexao WhatsApp via Baileys na pagina de configuracoes do inbox
 * Agora usa o componente SettingsWhatsappBaileys para configurações completas
 */
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import SettingsWhatsappBaileys from './SettingsWhatsappBaileys.vue';

export default {
  name: 'BaileysConnection',
  components: {
    SettingsSection,
    SettingsWhatsappBaileys,
  },
  props: {
    inbox: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBaileysChannel() {
      return (
        this.inbox.channel_type === 'Channel::Whatsapp' &&
        this.inbox.provider === 'baileys'
      );
    },
    // Caixa do WhatsApp Cortex ZNew (gateway cortex-zaileys) não se apresenta como Baileys.
    isZnew() {
      return this.inbox.provider_config?.gateway === 'znew';
    },
    title() {
      return this.isZnew
        ? this.$t('INBOX_MGMT.BAILEYS.CONNECTION.ZNEW_TITLE')
        : this.$t('INBOX_MGMT.BAILEYS.CONNECTION.TITLE');
    },
    description() {
      return this.isZnew
        ? this.$t('INBOX_MGMT.BAILEYS.CONNECTION.ZNEW_DESCRIPTION')
        : this.$t('INBOX_MGMT.BAILEYS.CONNECTION.DESCRIPTION');
    },
  },
};
</script>

<template>
  <div class="mx-8">
    <SettingsSection
      :title="title"
      :sub-title="description"
      :show-border="false"
    >
      <SettingsWhatsappBaileys
        v-if="isBaileysChannel"
        :inbox="inbox"
      />
      <div v-else class="p-4 text-center text-n-slate-11">
        Este inbox não é um canal WhatsApp Baileys.
      </div>
    </SettingsSection>
  </div>
</template>
